import React, {useContext} from "react";
import {arenaLabPage} from "../../../portfolio";
import StyleContext from "../../../contexts/StyleContext";
import "./ArenaLabTeam.css";

// Map tag names to consistent colors (0-19) - each unique skill gets its own color
const TAG_COLOR_MAP = {
  // Publication tags
  "Benchmarking": 0,
  "Social Navigation": 1,
  "Collaboration": 2,
  "Photorealistic": 3,
  "ROS2": 4,
  "Simulation": 5,
  "Human-Centric": 6,
  "AI Generation": 7,
  "Platform": 8,
  "Development": 9,
  "Web Platform": 10,
  "Dynamic Environments": 11,
  "Dynamics": 12,
  "Obstacle Avoidance": 13,
  "Dynamic": 14,
  "Deep RL": 15,
  "Navigation": 16,
  "Control": 17,
  // Team research interests
  "Human-Robot Interaction": 18,
  "Behavioral Modeling": 19,
  "Embodied AI": 0,
  "Robot Learning": 1,
  "Autonomous Navigation": 2,
  "Manipulation": 3,
  "Learning from Demonstration": 4,
  "Sim2Real Transfer": 5,
  "Multi-Agent RL": 6,
  "Robot Teams": 7,
  "Crowd Simulation": 8,
  "Computer Vision": 9,
  "Semantic Perception": 10,
  "Scene Understanding": 11,
  "Software Engineering": 12,
  "ROS Development": 13,
  "Robotics Simulation": 1,
  "3D Rendering": 2,
  "Machine Learning": 3,
  "3D Simulation": 4,
  "Foundation Models": 5,
  "LLMs for Robotics": 6,
  "Social Force Modeling": 7
};

const getTagColorIndex = (tagName) => {
  return TAG_COLOR_MAP[tagName] !== undefined ? TAG_COLOR_MAP[tagName] : Object.keys(TAG_COLOR_MAP).length % 20;
};

function ArenaLabTeam() {
  const {isDark} = useContext(StyleContext);

  return (
    <div className="arena-lab-section team-section" id="lab-team">
      <h2 className="section-title">Our Team</h2>
      <div className="team-grid">
        {arenaLabPage.teamMembers.map((member, index) => (
          <div key={index} className={`team-card ${isDark ? "dark-mode" : ""}`}>
            <div className={`team-image-wrapper member-role-${member.roleType}`}>
              <img src={member.image} alt={member.name} className="team-image" />
              <div className="role-badge">{member.position}</div>
            </div>
            <div className="team-content">
              <h3 className="team-name">{member.name}</h3>
              
              <p className="team-bio">{member.bio}</p>
              
              <div className="research-interests-section">
                <p className="interests-label">Research Interests</p>
                <div className="interests-tags">
                  {member.researchInterests.map((interest, i) => (
                    <span key={i} className={`interest-tag tag-${getTagColorIndex(interest)}`}>{interest}</span>
                  ))}
                </div>
              </div>

              {member.previousBackground && (
                <div className="previous-background-section">
                  <p className="previous-background-label">Previous Background</p>
                  <p className="previous-background-text">{member.previousBackground}</p>
                </div>
              )}

              <div className="team-contact">
                <a href={`mailto:${member.email}`} className="email-link">
                  ✉️ {member.email}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ArenaLabTeam;
